export class MapInvitation {
    public accessId: number;
    public mapTitle: string;
    public from: string;


}